import styled from 'styled-components';

import { fadeIn } from 'utils/style/animations';

import { ISideButtonWrappedProps, Sizes } from './types';

export const Container = styled.div<{ isMobile: boolean }>`
  width: 100%;
  position: relative;
  display: flex;
`;

export const CardContainerWrapper = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: column;
  width: inherit;
  margin: 0 auto;
  margin-bottom: 12px;
`;

export const CardWrapper = styled.span`
  display: flex;
  justify-content: center;
  margin: 0 ${Sizes.SPACER / 2}px;
  &:first-child {
    margin: 0 ${Sizes.SPACER / 2}px 0 0;
  }

  ${Styles.desktop`
    &:first-child {
      margin: 0 ${Sizes.SPACER / 2}px;
    }`}
`;
export const CardsWrapper = styled.div<{ $offset: number }>`
  display: flex;
  transform: translateX(-${p => p.$offset}px);
  transition: all 1s;
  padding: 20px 0px;
`;

export const CardContainer = styled.div<{
  isMobile: boolean;
  $innerPadding: number;
  $isMaxWidth: boolean;
}>`
  ${p => (p.isMobile ? 'display: flex; padding: 20px 1rem;' : 'overflow: hidden')};
  height: 100%;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  ::-webkit-scrollbar {
    -webkit-appearance: none;
    display: none;
  }
  margin: 0px
    ${p => (p.isMobile ? '0rem' : `calc(${p.$innerPadding}px - ${p.$isMaxWidth ? '0px' : '1rem'})`)};
`;

const SideButtonWrapped = styled.div<ISideButtonWrappedProps>`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 40px;
  z-index: ${Styles.zIndex.overlay};
  display: flex;
  align-items: center;
  transition: 0.3s;
  ${p => (p.isMobile ? `opacity: ${p.isOverflow ? 1 : 0};` : '')};
`;

export const RightButtonWrapper = styled(SideButtonWrapped)`
  right: ${p => (p.isMobile ? 0 : '4px')};
  justify-content: flex-end;
`;

export const LeftButtonWrapper = styled(SideButtonWrapped)`
  left: ${p => (p.isMobile ? 0 : '4px')};
  justify-content: flex-start;
`;

const CarouselButton = styled.button`
  min-width: 42px;
  min-height: 42px;
  border-radius: 50%;
  background-color: ${Styles.color.primary};
  color: ${Styles.color.white};
  border: none;
  cursor: pointer;
  font-weight: bold;
  font-size: 1.3rem;
  animation: 0.15s ${fadeIn};
  transition: 0.15s;
`;

export const RightCarouselButton = styled(CarouselButton)`
  > svg {
    padding-left: 2px;
  }
`;

export const LeftCarouselButton = styled(CarouselButton)`
  > svg {
    padding-right: 2px;
  }
`;

export const Spacer = styled.span`
  min-width: ${Sizes.SPACER}px;
`;
